export function SuccessIcon() {
  return <img src="/pictures/success-icon.png" alt="success-icon" />;
}
